export default class DriveSwitchPossession extends Error {
    constructor(message) {
        super(
            `You should change the possession before starting a new drive. ${message}`
        );
    }
}
